import { getNetworkEnvironment, NetworkEnvironment } from "../config/networks";

export type ContractName = "USDC" | "EarthfastEntrypoint" | "EarthfastProjects";

interface ContractData {
  address: string;
  abi: any[];
}

export const loadContract = async (
  contractName: ContractName,
): Promise<ContractData> => {
  const networkEnv = getNetworkEnvironment();

  try {
    const contract = await import(
      `../../abi/${networkEnv}/${contractName}.json`
    );
    return contract as ContractData;
  } catch (error) {
    console.error(
      `Failed to load contract data for ${contractName} on ${networkEnv}:`,
      error,
    );
    throw error;
  }
};

export const getContractAddress = async (
  contractName: ContractName,
): Promise<string> => {
  const contract = await loadContract(contractName);
  return contract.address;
};

export const getContractABI = async (
  contractName: ContractName,
): Promise<any[]> => {
  const contract = await loadContract(contractName);
  return contract.abi;
};
